export const defaultProvisionDevicesSorted = [{ dataField: "DeliveryDate", order: "desc" }];

export const defaultProvisionAccessoriesSorted = [{ dataField: "DeliveryDate", order: "desc" }];

export const defaultProvisionConsumablesSorted = [{ dataField: "DeliveryDate", order: "desc" }];